import React, { useEffect, useState } from 'react'
import { useClaimant } from '../context/col'
import useAsync from '../hooks/useAsync'
import useGetData from '../hooks/useGetData'
import ClaimantForm from '../components/forms/ClaimantForm'
import {
  CaseReportParamsType,
  CaseReportRespType,
  ClaimantDataType,
  InsuranceDataType,
  transformCaseReportRespToCaseReportParams,
} from '../models'
import { putCaseReport } from '../services/case-report/put'

export type ClaimantPageProps = {
  transitions: ClaimantPageTransitions
}

export type ClaimantPageTransitions = {
  goBack: () => void
  goToNextPage: () => void
}

const ClaimantPage = (props: ClaimantPageProps) => {
  const { state, dispatch } = useClaimant()
  const [ifEqual, setIfEqual] = useState<boolean>(true)

  const claimantData: ClaimantDataType | undefined =
    state.loadedCaseReportResp?.claimant ?? undefined

  const insuranceData: InsuranceDataType | undefined =
    state.loadedCaseReportResp?.insurance ?? undefined
  //console.log(state, 'state')

  const claimantFormData = {
    claimantData: claimantData,
    insuranceData: insuranceData,
  }

  const { fetch: doPutCaseReport, pending } = useAsync({
    promiseFn: (params: any) => putCaseReport(params),
    onData: () => {
      /*
      dispatch({ type: 'control_change', payload: { controlChange: true } })
      if (state.caseType === 'ME') history.push(pathToHealthProblem)
      if (state.caseType === 'CA') history.push(pathToCancellation)
      if (state.caseType === 'BA') history.push(pathToBaggage)
      if (state.caseType === 'PA') history.push(pathToPersonalAccident)
      if (state.caseType === 'PL') history.push(pathToLiability)
      if (state.caseType === 'TI') history.push(pathToTicket)
      */
      props.transitions.goToNextPage()
    },
    onError: (error) => {
      dispatch({ type: 'error', payload: { error: error.message } })
    },
  })

  const { fetch: fetchData } = useGetData({})

  React.useEffect(() => {
    fetchData()
  }, [fetchData])

  useEffect(() => {
    dispatch({ type: 'control_change', payload: { controlChange: ifEqual } })
  }, [dispatch, ifEqual])

  const handleClaimantDataPageBack = () => {
    props.transitions.goBack()
  }

  const handleClaimantDataPageSubmitted = (
    claimantDataParams: ClaimantDataType
  ) => {
    const {
      loadedCaseReportResp,
    }: { loadedCaseReportResp: CaseReportRespType | undefined } = state
    const newCaseReportDataResp = {
      ...loadedCaseReportResp,
      claimant: claimantDataParams,
    } as CaseReportRespType

    // 2. Pripravena finalni data, ktera se budou odesilat
    const caseReportParamsForUpdate: CaseReportParamsType =
      transformCaseReportRespToCaseReportParams(newCaseReportDataResp)

    // 3. aktualizujeme state -- do currentCaseReportData nastavime newCaseReportDataResp
    //    a zmenime 'stranku'
    dispatch({
      type: 'update_caseReportParams',
      payload: { data: newCaseReportDataResp, page: 2 },
    })

    doPutCaseReport({
      caseReportId: state.caseReportId,
      caseReportParams: caseReportParamsForUpdate,
    })
  }

  //console.log(state, 'state')

  return (
    <ClaimantForm
      caseReportId={state.caseReportId!}
      claimantFormData={claimantFormData}
      onPageContinue={handleClaimantDataPageSubmitted}
      onPageBack={handleClaimantDataPageBack}
      isContinueInProgress={pending}
      errorMessage={state.error}
      setIfEqual={setIfEqual}
      caseType={state.caseType}
    />
  )
}

export default ClaimantPage
